import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Elegant%20curated%20product%20flatlay%20with%20sneakers%20leather%20accessories%20and%20textiles%20arranged%20on%20a%20warm%20terrazzo%20surface%2C%20soft%20natural%20daylight%20from%20large%20windows%2C%20cream%20sand%20and%20terracotta%20color%20harmony%2C%20luxury%20editorial%20lifestyle%20photography%2C%20artful%20composition%20with%20organic%20shapes%20and%20negative%20space&width=1600&height=900&seq=hero-main-v2-k1&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="animate-fade-in-up">
          <span className="inline-block px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm text-white/90 text-xs md:text-sm font-medium tracking-wide mb-5">
            Updated Daily · Trusted by 50,000+ Shoppers
          </span>
        </div>

        <h1 className="animate-fade-in-up animation-delay-200 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading text-white leading-tight mb-5 max-w-3xl mx-auto">
          CSSBuy Spreadsheet &amp; Agent Shopping Hub <span className="text-accent-400">2026</span>
        </h1>

        <p className="animate-fade-in-up animation-delay-400 text-sm md:text-base text-white/75 max-w-2xl mx-auto mb-8 leading-relaxed">
          The most complete database for CSSBuy Spreadsheet, Kakobuy Spreadsheet, Superbuy Spreadsheet &amp; Oopbuy Spreadsheet comparisons, guides, and verified finds.
        </p>

        <div className="animate-fade-in-up animation-delay-600 flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap w-full sm:w-auto px-7 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-200"
          >
            CSSBuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap w-full sm:w-auto px-7 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white font-semibold text-sm md:text-base border border-white/25 hover:bg-white/25 transition-all duration-200"
          >
            Buy It Now
          </a>
          <Link
            to="/article/cssbuy-spreadsheet-complete-guide"
            className="whitespace-nowrap w-full sm:w-auto px-7 py-3.5 rounded-full bg-transparent text-white/80 font-medium text-sm md:text-base border border-white/20 hover:bg-white/10 transition-all duration-200"
          >
            Read Full Guide
          </Link>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a href="#categories" className="w-8 h-8 flex items-center justify-center text-white/50 hover:text-white/80 transition-colors">
          <i className="ri-arrow-down-s-line text-xl"></i>
        </a>
      </div>
    </section>
  );
}